import React from 'react';
import PropTypes from 'prop-types';
import Text from '@tds/core-text';
import HairlineDivider from '@tds/core-hairline-divider';

import { TopbarWrapper, LeftMenu, RightMenu, Box, Button } from './css';
import Menu from './menu';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Topbar = ({ token, userRights, userName }) => {
  const onClickLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const localizedStrings = useLocalizedStringsContext();
  const {
    topBar: { topBarTitle },
    headerLinks: { labelLogout }
  } = localizedStrings;

  return (
    <>
      <TopbarWrapper inline between={2}>
        <LeftMenu width={50} mdWidth={100}>
          <Box width={40} mdWidth={100}>
            <Text invert size="large" bold>
              {topBarTitle}
            </Text>
          </Box>
          <Box width={60} mdWidth={100}>
            {token && userRights && <Menu userRights={userRights} />}
          </Box>
        </LeftMenu>
        {token && userName && (
          <RightMenu width={30} inline between={3}>
            <Box style={{ paddingTop: '2px' }}>
              <Text invert>{`Welcome, ${userName}`}</Text>
            </Box>
            <HairlineDivider vertical />
            <Box>
              <Button onClick={onClickLogout}>{labelLogout}</Button>
            </Box>
          </RightMenu>
        )}
      </TopbarWrapper>
    </>
  );
};

Topbar.propTypes = {
  token: PropTypes.string.isRequired,
  userRights: PropTypes.objectOf(PropTypes.bool).isRequired,
  userName: PropTypes.string.isRequired
};

export default Topbar;
